export enum ErrorType {
  FILE_SIZE,
  FILE_EXTENSION,
  FILE_UPLOAD,
  AUTOCOMPLETE_EMPTY,
  AUTOCOMPLETE_INVALID,
  DEFAULT,
}

export enum MessageTypes {
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
}
